module.exports = __webpack_public_path__ + "static/Jeng-Oshiro-10a9d70f8450300c351835befb8979cb.jpg";